import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'José', 'Laura', 'Diego', 'Carmen', 'Roberto', 'Sofía', 'Miguel', 'Valentina', 'Juan'];
const CITIES = ['Buenos Aires', 'Santiago', 'Lima', 'Bogotá', 'Ciudad de México', 'Medellín', 'Montevideo', 'Quito', 'Córdoba', 'Rosario'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      triggerNotification();
    }, Math.random() * 7000 + 8000); // Random interval between 8-15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Auto hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  if (!data.name) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`} data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-4 max-w-xs border-l-4 border-teal-500" data-id="element-2">
        <div className="bg-teal-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
          <ShoppingBag className="w-5 h-5 text-teal-600" data-id="element-4" />
        </div>
        <div className="flex-1" data-id="element-5">
          <p className="text-sm font-medium text-gray-900" data-id="element-6">
            <span className="font-bold" data-id="element-7">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-8">acaba de comprar este kit</p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-9">
          <X className="w-4 h-4" data-id="element-10" />
        </button>
      </div>
    </div>;
}